import { createStore } from "vuex";
import { auth } from "./auth.module";
import EventBus from "vue3-eventbus";

export default createStore({
  state: {
    hideConfigButton: false,
    isPinned: true,
    showConfig: false,
    sidebarType: "bg-gradient-dark",
    isRTL: false,
    color: "info",
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    isDarkMode: false,
    navbarFixed:
      "position-sticky blur shadow-blur left-auto top-1 z-index-sticky px-0 mx-4",
    absolute: "position-absolute px-4 mx-0 w-100 z-index-2",
    isCollapsed: false
  },
  modules: {
    auth,
  },
  mutations: {
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    navbarMinimize(state) {
      const sidenav_show = document.querySelector(".g-sidenav-show");

      if (sidenav_show.classList.contains("g-sidenav-pinned")) {
        sidenav_show.classList.remove("g-sidenav-pinned");
        state.isPinned = true;
      } else {
        sidenav_show.classList.add("g-sidenav-pinned");
        state.isPinned = false;
      }
    },
    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true;
      } else {
        state.isNavFixed = false;
      }
    },
    toggleEveryDisplay(state) {
      state.showNavbar = !state.showNavbar;
      state.showSidenav = !state.showSidenav;
      state.showFooter = !state.showFooter;
    },
    toggleHideConfig(state) {
      state.hideConfigButton = !state.hideConfigButton;
    },
    color(state, payload) {
      state.color = payload;
    },
    headerColor(state, payload) {
      state.headerColor = payload;
    },
    labelColor(state, payload) {
      state.labelColor = payload;
    },
    buttonColor(state, payload) {
      state.buttonColor = payload;
    },
    toggleCollapse(state, defaultState = true) {
      if (defaultState) {
        if (window.innerWidth < 1200) {
          state.isCollapsed = false;
        } else {
          state.isCollapsed = !state.isCollapsed;
          EventBus.emit("ToggleCollapseEvent", 100);
        }
      } else {
        state.isCollapsed = defaultState;
        EventBus.emit("ToggleCollapseEvent", 500);
      }
    }
  },
  actions: {
    setColor({ commit }, payload) {
      commit("color", payload);
    },
    setHeaderColor({ commit }, payload) {
      commit("headerColor", payload);
    },
    setLabelColor({ commit }, payload) {
      commit("labelColor", payload);
    },
    setButtonColor({ commit }, payload) {
      commit("buttonColor", payload);
    },
  },
  getters: {},
});
